import { z } from 'zod'
import type { DropdownItem } from '@/shared/api/generated/models/DropdownItem'

export const myEduInternSearchSchema = z.object({
  search: z.string().catch(''),
  internship: z.string().catch(''),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z.enum(['intern', 'internship']).catch('intern'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})
export type MyEduInternSearch = z.infer<typeof myEduInternSearchSchema>
export const defaultMyEduInternSearch = myEduInternSearchSchema.parse({})
export function selectMyEduInterns(rows: DropdownItem[], search: MyEduInternSearch) {
  return rows
    .filter((row) => !search.internship || row.description === search.internship)
    .toSorted(
      (a, b) =>
        (search.sortBy === 'intern'
          ? a.text.localeCompare(b.text, 'lv', { sensitivity: 'base' })
          : (a.description ?? '').localeCompare(b.description ?? '', 'lv', {
              sensitivity: 'base',
            })) * (search.direction === 'desc' ? -1 : 1) || a.id.localeCompare(b.id)
    )
}
